"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.greyHover = exports.blackHover = exports.greenHover = exports.redHover = exports.blueHover = exports.textColor = exports.commonStyle = exports.SIZES = void 0;
var styled_components_1 = require("styled-components");
var colors_1 = require("../../../themes/colors");
var utilsOolib_1 = require("../../../utilsOolib");
var greyColor100 = colors_1.colors.greyColor100, greyColor80 = colors_1.colors.greyColor80, greyColor10 = colors_1.colors.greyColor10, white = colors_1.colors.white, greyColor5 = colors_1.colors.greyColor5, hoverRed = colors_1.colors.hoverRed, hoverInvertRed = colors_1.colors.hoverInvertRed, hoverGreen = colors_1.colors.hoverGreen, invertHoverGreen = colors_1.colors.invertHoverGreen;
exports.SIZES = {
    XS: '2rem',
    S: "3rem",
    M: "4rem",
};
var commonStyle = function (_a) {
    var size = _a.size;
    return "\n  padding: ".concat(size === 'XS' ? '0 .5rem' : '0 1rem', ";\n  position: relative;\n  display: inline-flex;\n  column-gap: 1rem;\n  align-items: center;\n  border-radius: 0.2rem;\n  white-space: nowrap;\n  height: ").concat(exports.SIZES[size], ";\n  max-width: 100%;\n");
};
exports.commonStyle = commonStyle;
var textColor = function (_a) {
    var invert = _a.invert;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), invert ? greyColor100 : white);
};
exports.textColor = textColor;
var blueHover = function (_a) {
    var invert = _a.invert, colors = _a.colors;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), invert ? (0, utilsOolib_1.getPrimaryColor10)(colors) : (0, utilsOolib_1.getPrimaryColor40)(colors), invert ? greyColor100 : (0, utilsOolib_1.getPrimaryColorText)(colors));
};
exports.blueHover = blueHover;
var redHover = function (_a) {
    var invert = _a.invert;
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), invert ? hoverInvertRed : hoverRed);
};
exports.redHover = redHover;
var greenHover = function (_a) {
    var invert = _a.invert;
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), invert ? invertHoverGreen : hoverGreen);
};
exports.greenHover = greenHover;
var blackHover = function (_a) {
    var invert = _a.invert;
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), invert ? greyColor5 : greyColor80);
};
exports.blackHover = blackHover;
var greyHover = function (_a) {
    var invert = _a.invert;
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) {\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), invert ? greyColor80 : greyColor10);
};
exports.greyHover = greyHover;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
